export default {"src":"/_next/static/media/category-leaders.1267a5ff.svg","height":9,"width":93,"blurWidth":0,"blurHeight":0};